import { render, staticRenderFns } from "./TeacherSearch.vue?vue&type=template&id=28de6106&scoped=true"
import script from "./TeacherSearch.vue?vue&type=script&lang=js"
export * from "./TeacherSearch.vue?vue&type=script&lang=js"
import style0 from "./TeacherSearch.vue?vue&type=style&index=0&id=28de6106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28de6106",
  null
  
)

export default component.exports